const LOAD_MENUITEMGROUPS = "LOAD_MENUITEMGROUPS";
const LOAD_MENUITEMGROUPS_SUCCESS = "LOAD_MENUITEMGROUPS_SUCCESS";
const LOAD_MENUITEMGROUPS_FAIL = "LOAD_MENUITEMGROUPS_FAIL";

const MENUITEMGROUPS_POST = "LOAD_MENUITEMGROUPS";
const MENUITEMGROUPS_DELETE = "LOAD_MENUITEMGROUPS_FAIL";

const MENUITEM_CUSTOMPRIVATE = "MENUITEM_CUSTOMPRIVATE";
const MENUITEM_CUSTOMPRIVATE_SUCCESS = "MENUITEM_CUSTOMPRIVATE_SUCCESS";
const MENUITEM_CUSTOMPRIVATE_FAIL = "MENUITEM_CUSTOMPRIVATE_FAIL";

export default function menuItemGroup(
  state = {
    data: [],
    isLoading: true,
    hasErrored: false,
    message: "",
  },
  action,
) {
  switch (action.type) {
    case LOAD_MENUITEMGROUPS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case MENUITEM_CUSTOMPRIVATE: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_MENUITEMGROUPS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_MENUITEMGROUPS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    case MENUITEM_CUSTOMPRIVATE_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case MENUITEM_CUSTOMPRIVATE_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        hasErrored: false,
      });
    }

    default:
      return state;
  }
}

export function getMenuItemGroups() {
  return {
    type: LOAD_MENUITEMGROUPS,
    payload: {
      request: {
        url: "MenuItemGroup/",
      },
    },
  };
}

export function verifyGroupsForInternalMenuItem(internalLink) {
  return {
    type: MENUITEM_CUSTOMPRIVATE,
    payload: {
      request: {
        url: `MenuItemGroup/Verify?internalLink=${internalLink}`,
      },
    },
  };
}

export function addOrEditMenuItemGroup(menuItemGroup) {
  return {
    type: MENUITEMGROUPS_POST,
    payload: {
      request: {
        url: "MenuItemGroup",
        method: "POST",
        data: menuItemGroup,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getMenuItemGroups());
        },
      },
    },
  };
}

export function deleteMenuItemGroup(id) {
  return {
    type: MENUITEMGROUPS_DELETE,
    payload: {
      request: {
        url: "MenuItemGroup/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getMenuItemGroups());
        },
      },
    },
  };
}
